import { StarIcon } from "@heroicons/react/20/solid";
import { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@/core/components/ui/stack";
import { cn } from "@/core/utils/utils";
import { normalizeRating } from "@/reviews/utils";

type RatingRow = {
  rating: number;
};

export const RatingCol = <T extends RatingRow = RatingRow>(): ColumnDef<T> => ({
  header: "Rating",
  accessorFn: (row) =>
    String(row.rating || "")
      .trim()
      .toLowerCase(),
  accessorKey: "rating",
  sortingFn: "basic",
  cell: ({ row }) => {
    const rating = normalizeRating(row.original.rating);

    return (
      <Stack direction="row" gap="xs" align="center">
        {Array.from({ length: 5 }).map((_, i) => (
          <StarIcon
            key={`star-${i}`}
            className={cn("h-4 w-4 text-gold-30", {
              "opacity-30": i >= rating,
            })}
          />
        ))}
      </Stack>
    );
  },
});
